import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsapHorizontalLoop } from './gsapHorizontalLoop';

// Swiper
import 'swiper/css';
window.Swiper = Swiper;
Swiper.use([Autoplay, Navigation]);

// GSAP
window.gsap = gsap;
window.gsapHorizontalLoop = gsapHorizontalLoop;
gsap.registerPlugin(SplitText, ScrollTrigger);
window.SplitText = SplitText;
window.ScrollTrigger = ScrollTrigger;

// Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);

// Init Alpine after page load
document.addEventListener('DOMContentLoaded', () => {
	Alpine.start();
});
